import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NotificationModel } from './notification.model'
import { FollowUpService } from '../../../sections/quotation/followup.service'
import { AuthStateService } from '../../../auth-state.service'
import { UserModel } from '../../../sections/users/user_model'
import { Router } from '@angular/router'

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.css',
})
export class NotificationComponent implements OnInit {
  constructor(
    private quotationFollowupService: FollowUpService,
    private authStateService: AuthStateService,
    private router: Router,
  ) {}

  userInfo: UserModel | null = null

  notifications: NotificationModel[] = []
  unreadNotificationsCount = 0
  showNotifications = false
  private readNotificationsKey = 'readNotifications'

  ngOnInit(): void {
    this.authStateService.userEvent.subscribe((user) => {
      if (user !== null) {
        this.userInfo = user
        const dateObj = new Date()
        const formattedDate = dateObj.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        })
        const isoDate = dateObj.toISOString()

        this.quotationFollowupService
          .getFollowUpsForDate(isoDate, user.id)
          .subscribe({
            next: (data: any[]) => {
              data.forEach((followUp: any) => {
                const message = `Follow-up scheduled on ${formattedDate} for quotation ID: ${followUp.quotationId}`
                if (
                  !this.notifications.some(
                    (n) => n.navigationExtras === followUp.id,
                  )
                ) {
                  this.notifications.push({
                    message,
                    navigationUrl: `/viewFollowUpDetails`,
                    navigationExtras: followUp.quotationId,
                  })
                }
              })
            },
          })
      }
    })
  }

  toggleNotifications(): void {
    this.showNotifications = !this.showNotifications
  }

  onNotificationClick(notification: NotificationModel): void {
    if (notification.navigationUrl) {
      this.toggleNotifications()
      this.router.navigate([
        notification.navigationUrl,
        notification.navigationExtras,
      ])
    }
  }
}
